(() => {
  document.addEventListener('click', event => {
    const summary = event.target.closest('summary[data-rk-service-parent-link="true"]');
    if (!summary || window.matchMedia('(max-width: 768px)').matches) return;
    const url = String(summary.dataset.link || '').trim();
    if (!url || url === '#') return;
    event.preventDefault();
    window.location.href = url;
  });
})();
